(function() {
    if (window.DependentVariantFilterLoaded) return;
    window.DependentVariantFilterLoaded = true;

    class DependentVariantFilter {
        constructor(container) {
            this.container = container;
            this.init();
        }

        init() {
            this.parentName = this.container.dataset.parentOption;
            this.childName = this.container.dataset.childOption;
            this.rulesString = this.container.dataset.filterRules;

            if (!this.parentName || !this.childName) {
                console.error("Dependent Variant Filter: Parent or Child option name is blank in Theme Editor settings.");
                return;
            }

            // 1. Get Option Indices (Now case-insensitive)
            this.parentIndex = this.getOptionIndex(this.parentName);
            this.childIndex = this.getOptionIndex(this.childName);

            if (!this.parentIndex || !this.childIndex) {
                console.warn(`Dependent Variant Filter: Could not find matching variant options on this product for Parent: "${this.parentName}" or Child: "${this.childName}". This feature will safely remain disabled for this product.`);
                return;
            }

            this.parseRules();
            this.getVariantData();

            // 2. Find Inputs (Expanded to catch different Shrine naming conventions)
            const parentEscaped = this.escapeQuotes(this.parentName);
            const childEscaped = this.escapeQuotes(this.childName);

            const parentSelectors = [
                `input[name="options[${parentEscaped}]"]`,
                `input[name="${parentEscaped}"]`,
                `select[name="options[${parentEscaped}]"]`,
                `select[name="${parentEscaped}"]`
            ].join(', ');

            const childSelectors = [
                `select[name="options[${childEscaped}]"]`,
                `select[name="${childEscaped}"]`
            ].join(', ');

            this.parentInputs = Array.from(this.container.querySelectorAll(parentSelectors));
            this.childSelect = this.container.querySelector(childSelectors);

            if (!this.parentInputs.length) {
                console.error(`Dependent Variant Filter: Parent HTML inputs for "${this.parentName}" not found. Shrine might be rendering them in an unexpected way.`);
                return;
            }
            if (!this.childSelect) {
                console.error(`Dependent Variant Filter: Child HTML dropdown for "${this.childName}" not found. Ensure the child option is set to a "Dropdown" in Theme Editor.`);
                return;
            }

            // 3. Clone options and bind events
            this.originalChildOptions = Array.from(this.childSelect.options).map(opt => opt.cloneNode(true));

            // Use event delegation on the container in case Shrine dynamically recreates inputs
            this.container.addEventListener('change', (e) => {
                if (this.parentInputs.includes(e.target)) {
                    this.onParentChange(false);
                }
            });

            // Execute immediately on load
            this.onParentChange(true);
        }

        escapeQuotes(str) {
            return str.replace(/"/g, '\\"');
        }

        getOptionIndex(name) {
            const lowerName = name.toLowerCase().trim();
            for (let i = 1; i <= 3; i++) {
                const optName = this.container.getAttribute(`data-option-${i}`);
                if (optName && optName.toLowerCase().trim() === lowerName) return i;
            }
            return null;
        }

        parseRules() {
            this.rules = {};
            if (!this.rulesString) return;
            
            const pairs = this.rulesString.split(',');
            pairs.forEach(pair => {
                const firstEqIndex = pair.indexOf('=');
                if (firstEqIndex > -1) {
                    const key = pair.substring(0, firstEqIndex).trim().toLowerCase();
                    const val = pair.substring(firstEqIndex + 1).trim().toLowerCase();
                    if (key && val) this.rules[key] = val;
                }
            });
        }

        getVariantData() {
            const script = this.container.querySelector('script[type="application/json"]');
            try {
                this.variants = JSON.parse(script.textContent);
            } catch (e) {
                console.error("Dependent Variant Filter: Failed to parse variant JSON.", e);
                this.variants = [];
            }
        }

        getCurrentParentValue() {
            if (!this.parentInputs.length) return null;
            if (this.parentInputs[0].tagName === 'SELECT') {
                return this.parentInputs[0].value;
            }
            const checked = this.parentInputs.find(input => input.checked);
            return checked ? checked.value : this.parentInputs[0].value;
        }

        onParentChange(isInitialLoad = false) {
            const parentVal = this.getCurrentParentValue();
            if (!parentVal) return;
            
            const parentValLower = parentVal.toLowerCase();
            const keyword = this.rules[parentValLower]; 

            const currentChildVal = this.childSelect.value;
            this.childSelect.innerHTML = '';

            let hasValidMatch = false;
            let firstAvailableOptVal = null;
            let firstValidOptVal = null;

            this.originalChildOptions.forEach(opt => {
                const childVal = opt.value;
                const childValLower = childVal.toLowerCase();

                if (keyword && !childValLower.includes(keyword)) return;

                const matchingVariants = this.variants.filter(v => {
                    return v[`option${this.parentIndex}`] === parentVal &&
                           v[`option${this.childIndex}`] === childVal;
                });

                if (matchingVariants.length === 0) return; 

                const newOpt = opt.cloneNode(true);
                this.childSelect.appendChild(newOpt);

                const isAvailable = matchingVariants.some(v => v.available);
                if (!firstValidOptVal) firstValidOptVal = newOpt.value;
                if (!firstAvailableOptVal && isAvailable) firstAvailableOptVal = newOpt.value;

                if (newOpt.value === currentChildVal) {
                    hasValidMatch = true;
                }
            });

            if (!hasValidMatch) {
                const valToSelect = firstAvailableOptVal || firstValidOptVal;
                if (valToSelect) this.childSelect.value = valToSelect;
            } else {
                this.childSelect.value = currentChildVal; 
            }

            if (!isInitialLoad || !hasValidMatch) {
                this.childSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    function initFilters() {
        document.querySelectorAll('variant-selects[data-dependent-filter-enabled="true"]').forEach(el => {
            if (!el.dataset.dependentFilterInitialized) {
                el.dataset.dependentFilterInitialized = 'true';
                new DependentVariantFilter(el);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', initFilters);
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        initFilters();
    }

    const observer = new MutationObserver((mutations) => {
        let shouldInit = false;
        for (const mutation of mutations) {
            if (mutation.addedNodes.length) {
                for (const node of mutation.addedNodes) {
                    if (node.nodeType === 1 && (node.tagName === 'VARIANT-SELECTS' || node.querySelector('variant-selects'))) {
                        shouldInit = true;
                        break;
                    }
                }
            }
            if (shouldInit) break;
        }
        if (shouldInit) initFilters();
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();